let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("47mn7")).then(() => parcelRequire('ilqtW'));